import React from "react";
import { useSelector } from "react-redux";
import * as R from "ramda";

import history from "../history";
import Spinner from "../components/feedback/Spinner";

const Linkedin = () => {
  const isHeadquarter = useSelector(
    R.pipe(
      R.pathOr([], ["user", "roles"]),
      R.includes("headadmin")
    )
  );

  React.useEffect(() => {
    const url = new URL(window.location.href);
    const code = url.searchParams.get("code");
    const redirectUri = localStorage.getItem("redirect_uri");

    if (redirectUri && code) {
      const newUrl = new URL(redirectUri);

      newUrl.searchParams.set("code", code);

      if (!isHeadquarter) {
        localStorage.removeItem("redirect_uri");

        return history.push(`${newUrl.pathname}${newUrl.search}`);
      } else {
        localStorage.setItem("redirect_uri", newUrl.href);
      }
    }

    return history.push("/");
  }, [isHeadquarter]);

  return <Spinner />;
};

export default Linkedin;
